// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'oswald'","fontWeight":400},"className":"__className_e6ca29","variable":"__variable_e6ca29"};